import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { EditQuickButton, DeleteQuickButton } from "../../../revampComponents/Atom/Buttons";
import RequestIcon from "./../../../assets/img/EventDashoardLogo/Request.svg";
import CloneEventProfileModal from "./EventProfileModal/CloneEventProfileModal";
import DeleteProfileModal from "./EventProfileModal/DeleteProfileModal";
import { deleteProfile } from "../../../revampCRUD/eventProfile.curd";
import { successToaster, errorToaster } from "../../../reusable/common";
import { APIStatusCode } from "../../../services/util";
import { EVENT_ROLE_TYPE } from "../../../reusable/common";
import TippyIcon from "../../../revampComponents/Atom/TippyIcon";

const ProfileTable = ({
  profiles = [],
  onEdit,
  onClone,
  onUsers,
  fetchEventProfiles,
  apiLoading,
}) => {
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [profileId, setProfileId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteLoader, setDeleteLoader] = useState(false)


  const handleDelete = async (profileID) => {
    setDeleteLoader(true)
    try {
      const res = await deleteProfile(profileID);
      if (res.status === APIStatusCode.STATUS_CODE_SUCCESS) {
        successToaster(res.data || []);
        setShowDeleteModal(false);
        fetchEventProfiles();
      } else {
        throw new Error("Unexpected response from API");
      }
    } catch (err) {
      console.error(err);
      errorToaster(err?.message);
    } finally {
      setDeleteLoader(false)
    }
  };

  const columns = [
    {
      name: "Profile Name",
      selector: (row) => row?.name,
      sortable: true,
      grow: 2,
      width: "33%",
      style: {
        fontWeight: 500,
        fontSize: "14px",
      },
    },
    {
      name: "Description",
      selector: (row) => row?.description || "-",
      sortable: false,
      wrap: true,
      grow: 4,
      width: "33%",
    },
    {
      name: "Quick Actions",
      width: "33%",
      cell: (row) => {
        const isCreator = String(row?.organiser_role_id) === String(EVENT_ROLE_TYPE.EVENT_CREATOR);

        return (
          <div className="quick-actions-btn">
            <EditQuickButton onClick={() => onEdit(row)} />

            <TippyIcon content={"Team"} placement="bottom">
              <img
                src={RequestIcon}
                alt="Add User"
                className="quick-action-img"
                onClick={() => onUsers(row)}
              />
            </TippyIcon>
            <TippyIcon
              content={isCreator ? "Delete" : "You are not the creator of this profile"}
              placement="bottom"
            >
              <span className="delete-icon">
                <DeleteQuickButton
                  onClick={() => {
                    if (isCreator) {
                      setShowDeleteModal(true);
                      setProfileId(row?.profile_id);
                    }
                  }}
                  disabled={!isCreator}
                  size="15px"
                  style={{
                    cursor: isCreator ? "pointer" : "not-allowed",
                    opacity: isCreator ? 1 : 0.5,

                  }}
                />
              </span>
            </TippyIcon>

          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
      grow: 2,
    }
  ];

  return (
    <div className="profile-table-wrapper">
      <DataTable
        columns={columns}
        data={profiles}
        noHeader
        responsive
        highlightOnHover
        pagination
        paginationPerPage={rowsPerPage}
        paginationCurrentPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newLimit, page) => {
          setRowsPerPage(newLimit);
          setCurrentPage(page);
        }}
        progressPending={apiLoading}
      />

      <CloneEventProfileModal
        show={showCloneModal}
        onClose={() => setShowCloneModal(false)}
        onClone={onClone}
      />

      <DeleteProfileModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={() => handleDelete(profileId)}
        deleteLoader={deleteLoader}
      />

      <style>{`
        .profile-table-wrapper {
          background: #fff;
          padding: 0px 30px;
          margin-top: 30px;
        }

        .quick-actions-btn {
          display: flex;
          gap: 12px;
          justify-content: center;
          align-items: center;
        }

        .quick-action-img {
          cursor: pointer;
        }

        .rdt_TableCell {
          font-size: 14px !important;
          justify-content: center;
          text-align: center;
        }

        .rdt_TableCol {
          height: 100%;
          text-align: center;
          justify-content: center;
        }

        .rdt_TableCol_Sortable {
          text-align: center;
          justify-content: center;
          font-weight: bold;
          margin-left: 16px;
          font-size: 14px;
        }

        .rdt_TableHeader + div {
          padding-bottom: 0px;
          overflow-y: auto;
          margin-bottom: 0px;
          scrollbar-width: thin;
          overflow-x: scroll;
          overflow-y: hidden;
          scrollbar-color: #888 transparent;
        }

        .rdt_TableHeader {
          display: none;
        }

        .rdt_TableHeadRow {
          background: #f5f5f0 !important;
          color: black;
        }


        .delete-icon {
          display: inline-block;
          line-height: 0;
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default ProfileTable;
